import { AppConfig } from '../app/core/config/app-config';

export const environment: AppConfig = {
  production: false,
  api: {
    baseUrl: '',
    path: '/api/boldest',
    apiKey: null,
    timeoutMs: 20000,
  },
  i18n: {
    defaultLanguage: 'es-ES',
    availableLanguages: ['es-ES', 'es-EU', 'en-UK', 'fr-FR'],
  },
  totem: {
    designWidth: 1280,
    designHeight: 1761,
    idleResetMs: 60000,
  },
  map: {
    accessToken:
      'pk.eyJ1IjoiZ3ZhbSIsImEiOiJjbXNyOWlsbW8wMTEzMnlzY2JxeTV0Nm0zIn0.aE3bADOcYfHJZcTZ0vmkEA',
    styleUrl: 'mapbox://styles/mapbox/outdoors-v12',
    center: { latitude: 42.6712, longitude: -2.0289 },
    zoom: 10,
    minZoom: 8,
    maxZoom: 16,
  },
};
